module.exports = __webpack_public_path__ + "img/versapay-overview-2.5643a9e5.png";